function isObject(item: any): boolean {
  return item !== null && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Deep merges multiple objects into a new object starting with defaults.
 * Arrays and primitives are replaced, while objects are recursively merged.
 */
export function deepMerge<T extends Record<string, any>>(target: T, ...sources: (Record<string, any> | undefined | null)[]): T {
  // Start with a clean deep clone of target so target is never mutated
  let result: any = JSON.parse(JSON.stringify(target));

  for (const source of sources) {
    if (!source || typeof source !== 'object') continue;

    for (const key of Object.keys(source)) {
      const sourceVal = source[key];
      const targetVal = result[key];

      if (sourceVal === undefined) {
        continue;
      }

      if (isObject(sourceVal) && isObject(targetVal)) {
        result[key] = deepMerge(targetVal, sourceVal);
      } else if (Array.isArray(sourceVal)) {
        // Deep clone arrays
        result[key] = JSON.parse(JSON.stringify(sourceVal));
      } else {
        result[key] = sourceVal;
      }
    }
  }

  return result;
}
